"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LRUCache {
    constructor(maxEntries = 100) {
        this.entries = new Map();
        this.maxEntries = maxEntries;
    }
    get(key) {
        const hasKey = this.entries.has(key);
        let entry;
        if (hasKey) {
            entry = this.entries.get(key);
            this.entries.delete(key);
            this.entries.set(key, entry);
        }
        return entry;
    }
    put(key, value) {
        if (this.entries.size >= this.maxEntries) {
            const keyToDelete = this.entries.keys().next().value;
            this.entries.delete(keyToDelete);
        }
        this.entries.set(key, value);
    }
}
exports.default = LRUCache;
//# sourceMappingURL=LRUCache.js.map